export const orderItemReferenceTypeToLabel: Record<string, string> = {
  course: 'Warsztat',
  meeting: 'Terapia',
  webinar: 'Webinar',
}
